import { useState, useRef } from 'react';

function useLazyRef(getValue) {
  const [value] = useState(getValue);
  const ref = useRef(value);
  return ref;
}

export { useLazyRef };
